module.exports = __webpack_public_path__ + "media/38.f8ccfbd3.mp3";